export const uploadFile = {
  uploadFiles: {
    zh: '上传文件',
    en: 'Upload files',
    pu: 'Upload de arquivos'
  },
  uploadSheet: {
    zh: '上传表格',
    en: 'Upload spreadsheet',
    pu: 'Upload planilha'
  },
  lotNumber: {
    zh: '批号',
    en: 'Lot number',
    pu: 'Número do lote'
  },
  lotNumberPlaceholder: {
    zh: '按批号搜索',
    en: 'Search by lot number',
    pu: 'Pesquise pelo número do lote'
  },
  date: {
    zh: '日期',
    en: 'Date',
    pu: 'Data'
  },
  filesQuantity: {
    zh: '文件数量',
    en: 'Files quantity',
    pu: 'Qtde. Arquivos'
  },
  download: {
    zh: '下载',
    en: 'Download',
    pu: 'Download'
  },
  uploadFileTitle: {
    zh: '上传文件',
    en: 'Upload file',
    pu: 'Upload do arquivo'
  },
  uploadFileParagraph: {
    zh: '填写下面的字段以完成所有编辑文件的上传',
    en: 'Fill in the fields below to complete the upload of the editing files',
    pu: 'Preencha os campos logo abaixo para realizar o todo o upload do arquivo das edições'
  },

  // formUploadFile
  importDate: {
    zh: '导入日期',
    en: 'Import date',
    pu: 'Data da importação'
  },
  editionCode: {
    zh: '版本代码',
    en: 'Edition code',
    pu: 'Cód. Edição'
  },
  dragFile: {
    zh: '拖拽文件到此处或点击上传',
    en: 'Drag file here or click to upload',
    pu: 'Arraste o arquivo aqui ou clique para fazer upload'
  },
  submit: {
    zh: '提交',
    en: 'Submit',
    pu: 'Enviar'
  },
  template: {
    zh: '模板',
    en: '',
    pu: 'Modelo'
  },
  customerLeadTime: {
    zh: '客户时效',
    en: 'Customer Lead Time',
    pu: 'Prazo do Cliente'
  },
  expressTimeliness: {
    zh: '快递时效',
    en: 'Express Timeliness',
    pu: 'SLA de expresso'
  },
  internalLeadTime: {
    zh: '内部时效',
    en: 'Internal Lead Time',
    pu: 'Prazo Interno'
  },
  timingStage: {
    zh: '时效环节',
    en: 'Timing Stage',
    pu: 'Etapa de Tempo'
  },
  addInternalLeadTime: {
    zh: '新增内部时效',
    en: 'Add Internal Lead Time',
    pu: 'Adicionar Prazo Interno'
  },
  regionLeadTime: {
    zh: '大区时效',
    en: 'Region Lead Time',
    pu: 'Prazo Regional'
  },
  branchTimeliness: {
    zh: '网点时效',
    en: 'Branch Timeliness',
    pu: 'Prazo da Agência'
  },
  editInternalLeadTime: {
    zh: '编辑内部时效',
    en: 'Edit Internal Lead Time',
    pu: 'Editar Prazo Interno'
  },
  assessmentStage: {
    zh: '考核环节',
    en: 'Assessment Stage',
    pu: 'Etapa de Avaliação'
  },
  timingStartTime: {
    zh: '时效起点时间',
    en: 'Timing Start Time',
    pu: 'Hora de Início do Prazo'
  },
  timingDays: {
    zh: '时效天数',
    en: 'Timing Days',
    pu: 'Dias do Prazo'
  },
  requiredDeliveryTime: {
    zh: '要求送达时间',
    en: 'Required Delivery Time',
    pu: 'Hora de Entrega Exigida'
  },
  leadTimeHours: {
    zh: '时效时长(H)',
    en: 'Lead Time Duration (H)',
    pu: 'Duração do Prazo (H)'
  },
  fileUploadRestrictions: {
    zh: '只能上传.xlsx .csv文件，只读表格第一列单号',
    en: 'Only .xlsx and .csv files allowed, only reads tracking numbers from the first column',
    pu: 'Apenas arquivos .xlsx e .csv permitidos, lê apenas números de rastreamento da primeira coluna'
  },
  exportListData: {
    zh: '导出列表数据',
    en: 'Export List Data',
    pu: 'Exportar Dados da Lista'
  },
  statisticsDate: {
    zh: '统计日期',
    en: 'Statistics Date',
    pu: 'Data de Estatísticas'
  },
  missedOperationStatistics: {
    zh: '漏操作统计',
    en: 'Missed Operation Statistics',
    pu: 'Estatísticas de Operações Omitidas'
  },
  collectionLoading: {
    zh: '揽收装车',
    en: 'Collection Loading',
    pu: 'Carregamento de Coleta'
  },
  totalMissedScans: {
    zh: '漏扫总数',
    en: 'Total Missed Scans',
    pu: 'Total de Digitalizações Omitidas'
  },
  collectionMissedScans: {
    zh: '揽收漏扫数',
    en: 'Collection Missed Scans',
    pu: 'Digitalizações Omitidas de Coleta'
  },
  totalCollections: {
    zh: '总揽收数',
    en: 'Total Collections',
    pu: 'Total de Coletas'
  },
  collectionMissedScanRate: {
    zh: '揽收漏扫率',
    en: 'Collection Missed Scan Rate',
    pu: 'Taxa de Digitalizações Omitidas de Coleta'
  },
  collectionLoadingMissedScans: {
    zh: '揽收装车漏扫数',
    en: 'Collection Loading Missed Scans',
    pu: 'Digitalizações Omitidas de Carregamento de Coleta'
  },
  collectionLoadingCount: {
    zh: '揽收装车数',
    en: 'Collection Loading Count',
    pu: 'Contagem de Carregamento de Coleta'
  },
  loadingMissedScanRate: {
    zh: '装车漏扫率',
    en: 'Loading Missed Scan Rate',
    pu: 'Taxa de Digitalizações Omitidas de Carregamento'
  },
  dispatchMissedScans: {
    zh: '发件漏扫数',
    en: 'Dispatch Missed Scans',
    pu: 'Digitalizações Omitidas de Despacho'
  },
  dispatchCount: {
    zh: '发件数',
    en: 'Dispatch Count',
    pu: 'Contagem de Despacho'
  },
  dispatchMissedScanRate: {
    zh: '发件漏扫率',
    en: 'Dispatch Missed Scan Rate',
    pu: 'Taxa de Digitalizações Omitidas de Despacho'
  },
  arrivalMissedScans: {
    zh: '到件漏扫数',
    en: 'Arrival Missed Scans',
    pu: 'Digitalizações Omitidas de Chegada'
  },
  arrivalCount: {
    zh: '到件数',
    en: 'Arrival Count',
    pu: 'Contagem de Chegada'
  },
  arrivalMissedScanRate: {
    zh: '到件漏扫率',
    en: 'Arrival Missed Scan Rate',
    pu: 'Taxa de Digitalizações Omitidas de Chegada'
  },
  operator: {
    zh: '操作人员',
    en: 'Operator',
    pu: 'Operador'
  },
  missedScanType: {
    zh: '漏扫类型',
    en: 'Missed Scan Type',
    pu: 'Tipo de Digitalização Omitida'
  },
  missedScanHub: {
    zh: '漏扫网点',
    en: 'Missed Scan Hub',
    pu: 'Centro de Digitalização Omitida'
  },
  missedScanState: {
    zh: '漏扫所属州',
    en: 'Missed Scan State',
    pu: 'Estado da Digitalização Omitida'
  },
  missedScanRegion: {
    zh: '漏扫所属大区',
    en: 'Missed Scan Region',
    pu: 'Região da Digitalização Omitida'
  },
  skuInformation: {
    zh: 'SKU信息',
    en: 'SKU Information',
    pu: 'Informação do SKU'
  },
  skuSystemCode: {
    zh: 'SKU系统代码',
    en: 'SKU System Code',
    pu: 'Código do Sistema SKU'
  },
  productName: {
    zh: '产品名称',
    en: 'Product Name',
    pu: 'Nome do Produto'
  },
  productSkuCode: {
    zh: '产品SKU代码',
    en: 'Product SKU Code',
    pu: 'Código SKU do Produto'
  },
  appearanceDimensions: {
    zh: '外观尺寸(m³)',
    en: 'Appearance Dimensions (m³)',
    pu: 'Dimensões Externas (m³)'
  },
  grossWeight: {
    zh: '毛重(KG)',
    en: 'Gross Weight (KG)',
    pu: 'Peso Bruto (KG)'
  },
  uploadSkuInfoFile: {
    zh: '上传SKU信息文件',
    en: 'Upload SKU Information File',
    pu: 'Carregar Arquivo de Informação SKU'
  },
  dragOrClickToUpload: {
    zh: '将文件拖到此处，或点击上传',
    en: 'Drag file here or click to upload',
    pu: 'Arraste o arquivo aqui ou clique para carregar'
  },
  skuTemplateDownload: {
    zh: 'SKU信息模板下载',
    en: 'SKU Information Template Download',
    pu: 'Download do Modelo de Informação SKU'
  },
  productSkuCodeUnique: {
    zh: '产品SKU代码不能重复',
    en: 'Product SKU code cannot be duplicated',
    pu: 'Código SKU do produto não pode ser duplicado'
  },
  senderPostalCode: {
    zh: '发件邮编',
    en: 'Sender Postal Code',
    pu: 'CEP do Remetente'
  },
  recipientPostalCode: {
    zh: '收件邮编',
    en: 'Recipient Postal Code',
    pu: 'CEP do Destinatário'
  }
};
